<template>
    <svg viewBox="0 0 16 16" fill="currentColor">
        <circle cx="3" cy="8" r="1.25" />
        <circle cx="8" cy="8" r="1.25" />
        <circle cx="13" cy="8" r="1.25" />
    </svg>
</template>

<script lang="ts" setup vapor>
defineOptions({ name: 'EllipsisIcon' });
</script>
